<div class="container">
  <div class="row">
    <div class="col">
      <div class="video-section__container mx-auto">
        <h2>Watch an at-home screening demonstration</h2>
        <p class="mb-4">
          At home testing kits are a way to screen the whole family. To learn how it works, check out this how to video
          showing screening with an at-home test kit.
        </p>
        <div video-carousel [videoCarouselData]="videoData" [transcript]="true"></div>
      </div>
    </div>
  </div>
</div>